<template>
  <v-list-item v-if="!deletedItem">
    <v-list-item-avatar>
      <v-img :src="item.User.Avatar"></v-img>
    </v-list-item-avatar>

    <v-list-item-content>
      <v-list-item-title>
        <span
          style="font-size: 14px"
          class="font-weight-bold defaultColor--text mb-0"
        >
          {{ item.User.FullName }}
          <span class="font-weight-regular">{{ " " + item.Text }}</span>
        </span>
      </v-list-item-title>

      <v-list-item-subtitle class="mt-1">
        <span style="font-size: 11px" class="greyColorDark--text mr-2">{{
          moment(item.CreatedAt).locale("tr").fromNow()
        }}</span>
        <span
          v-if="item.LikeCount > 0"
          style="font-size: 12px"
          class="hover-underline mr-2 defaultColor--text"
          >{{ item.LikeCount }} {{ $t("feed.userLike") }}
        </span>
        <v-btn
          v-if="!hideAnswerButton"
          color="defaultColor"
          text
          class="white--text text-capitalize mr-2"
          rounded
          x-small
          @click="$emit('commentAnswer', item)"
        >
          {{ $t("buttons.reply") }}
        </v-btn>
        <v-btn
          v-if="deleteCommentButtonStatus"
          color="defaultColor"
          text
          :loading="deleteCommentLoading"
          :diasbled="deleteCommentLoading"
          class="white--text text-capitalize"
          rounded
          x-small
          @click="deleteComment(item)"
        >
          {{ $t("buttons.delete") }}
        </v-btn>
      </v-list-item-subtitle>
    </v-list-item-content>

    <v-list-item-action>
      <v-btn icon @click="likeStatusComment(item)">
        <v-icon color="defaultColorLightTwo">{{
          item.LikeStatus ? "mdi-cards-heart" : "mdi-cards-heart-outline"
        }}</v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import PostService from "../../services/PostService.js";

export default {
  data() {
    return {
      deletedItem: false,
      deleteCommentLoading: false,
    };
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    hideAnswerButton: {
      type: Boolean,
    },
  },
  components: {},
  mounted() {
     [...document.querySelectorAll('.v-progress-circular')].forEach(item => {
      item.style.width = '60%';
      item.style.height = '60%';
    })
  },
  methods: {
    //Lik - Unlike Actions
    likeStatusComment(item) {
      if (item.LikeStatus) {
        // false yapma servisi
        this.unLikeFeedComment(item);
      } else {
        // true yapma servisi
        this.likeFeedComment(item);
      }
    },

    unLikeFeedComment(item) {
      //this.likeFeedLoading = true;
      // this.likeFeedLoading = false;
      PostService.unLikeComment(item.Id)
        .then((res) => {
          item.LikeStatus = false;
          item.LikeCount--;
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {
          //this.likeFeedLoading = false;
        });
    },

    likeFeedComment(item) {
      //this.likeFeedLoading = true;
      // this.likeFeedLoading = false;
      PostService.likeComment(item.Id)
        .then((res) => {
          item.LikeStatus = true;
          item.LikeCount++;
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {
          //this.likeFeedLoading = false;
        });
    },

    //DeleteComment
    deleteComment(item) {
      if (!item.ParentId) {
        //Main Comment
        this.deleteMainComment(item);
      } else {
        //ChildComent
        this.deleteChildComment(item);
      }
    },

    deleteMainComment(item) {
      this.deleteCommentLoading = true
      PostService.deleteComment(item.RelatedEntityId, item.Id)
        .then((res) => {
          this.deletedItem = true;
          this.$emit("successDeleteComment", item);
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {
          this.deleteCommentLoading = false
        });
    },

    deleteChildComment(item) {
      this.deleteCommentLoading = true
      PostService.deleteCommentChild(item.Id)
        .then((res) => {
          this.deletedItem = true;
          this.$emit("successDeleteComment", item);
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {
          this.deleteCommentLoading = false
        });
    },
  },
  computed: {
    getLikerUnderine() {
      if (this.item.LikeCount !== 0) {
        return "hover-underline";
      }
    },

    //If admin and own comment
    deleteCommentButtonStatus() {
      if (this.$store.state.user.Id == this.item.UserId) {
          return true
        } else if(this.$store.state.user.Type.toLowerCase() != "standart"){
          return true
        }else{
          false
        }
    },
  },
};
</script>
